import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import {
  PrognoseAbweichungKPI,
  SollstundenAbweichungKPI,
  ZielAbweichungKPI,
} from './KPI';
import Chart from './Chart/Chart';
import { Suspense, useEffect, useState } from 'react';
import { useTagebuchEinstellungen } from '@/domain/controlling/hooks/useTagebuchEinstellungen';
import { Skeleton } from '@/components/ui/skeleton';
import { useStandortContext } from '@/features/standortContext/StandortContext';

// eslint-disable-next-line max-lines-per-function
export function PlanungWrapper() {
  const {
    currentStandort: { id: standortId },
  } = useStandortContext();
  const { umsatzplanungAnzeige: tagebuchAnzeige } =
    useTagebuchEinstellungen(standortId);
  const defaultSelectedTab =
    tagebuchAnzeige === 'ABSATZ_PRODUKTIVITAET' ? 'absatz' : 'umsatz';
  const [selectedTab, setSelectedTab] = useState(defaultSelectedTab);

  useEffect(() => {
    setSelectedTab(
      tagebuchAnzeige === 'ABSATZ_PRODUKTIVITAET' ? 'absatz' : 'umsatz',
    );
  }, [tagebuchAnzeige]);

  return (
    <div className="flex flex-col gap-4">
      <h4 className="text-xl font-bold">Planung</h4>
      <Suspense fallback={<Skeleton className="h-[468px] w-[1450px]" />}>
        <Tabs
          className="flex flex-col gap-10 w-full bg-white rounded-md p-5"
          value={selectedTab}
          onValueChange={setSelectedTab}>
          <div className="flex justify-between items-start">
            <TabsContent
              value="umsatz"
              className="w-2/3 flex items-start justify-between data-[state=inactive]:hidden m-0">
              <ZielAbweichungKPI type="umsatz" />
              <PrognoseAbweichungKPI type="umsatz" />
              <SollstundenAbweichungKPI type="umsatz" />
            </TabsContent>
            <TabsContent
              value="absatz"
              className="w-2/3 flex items-start justify-between data-[state=inactive]:hidden m-0">
              <ZielAbweichungKPI type="absatz" />
              <PrognoseAbweichungKPI type="absatz" />
              <SollstundenAbweichungKPI type="absatz" />
            </TabsContent>
            {tagebuchAnzeige === 'UMSATZ_ABSATZ_PRODUKTIVITAET' && (
              <TabsList>
                <TabsTrigger value="umsatz">Umsatz</TabsTrigger>
                <TabsTrigger value="absatz">Absatz</TabsTrigger>
              </TabsList>
            )}
          </div>
          <TabsContent value="umsatz">
            <Chart type="umsatz" />
          </TabsContent>
          <TabsContent value="absatz">
            <Chart type="absatz" />
          </TabsContent>
        </Tabs>
      </Suspense>
    </div>
  );
}
